// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rsy5","footer":"styles_footer__JFrVC","passCodeTooltip":"styles_passCodeTooltip__3bT1y"};